export enum EMPLOYEE_MODE {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
export enum CCKM_MODE {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
export enum APPROVE_STATUS {
  "00" = "Lập bảng",
  "01" = "Chờ duyệt",
  "02" = "Quản lý duyệt",
  "03" = "Kế toán duyệt",
  "04" = "Dám đốc duyệt",
}

export enum APPROVE_ACTION {
  APPROVAL = "APPROVAL",
  CANCEL = "CANCEL",
  NOT_APPROVAL = "NOT_APPROVAL",
}

export enum APPROVE_ACTION_CODE {
  APPROVED = 1,
  WAIT_APPROVED = 0,
}
